var mentions_default = {
  "mentionPalette": "pyRrE",
  "mention": "z7ky-",
  "mentionViewer": "jU3-o",
  "mentionSuggestionsEntry": "z813x",
  "mentionSuggestionsEntryFocused": "-vMFx",
  "mentionSuggestionsEntryText": "YBMH1",
  "mentionSuggestionsEntryAvatar": "oy2vg",
  "mentionSuggestions": "e-GqX",
  "cursorDefault": "xUxl7",
  "cursorPointer": "QalgQ"
};
export {
  mentions_default as default
};
//# sourceMappingURL=mentions-scss.js.map
